// extracted by mini-css-extract-plugin
module.exports = {"main":"DummyPlayer_main__2PFSz","overlay":"DummyPlayer_overlay__3Wuyy","mainContainer":"DummyPlayer_mainContainer__1j--V"};